export default "__VITE_ASSET__C$aWWaxT__"